// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"777":"dc96cfa39cc3a3f9db15","913":"730b96ff10d43ae9e3d4"}[chunkId] + ".js";
};